import clientApi from '~/clientApi';

export const getInstagramContents = async (
  contentIds: string[],
  sharedToken?: string,
) => {
  const fetchContent = contentIds.map((id) =>
    clientApi.content.read({ id, _sharedToken: sharedToken }),
  );

  return await Promise.all(fetchContent);
};
